import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 0C3.576 0 0 3.576 0 8s3.576 8 8 8 8-3.576 8-8-3.576-8-8-8m0 14.4A6.41 6.41 0 0 1 1.6 8c0-3.528 2.872-6.4 6.4-6.4s6.4 2.872 6.4 6.4-2.872 6.4-6.4 6.4" }, null, -1),
    _createElementVNode("path", { d: "M4.123 6.892a1.077 1.077 0 0 0 0 2.154h.008a1.077 1.077 0 1 0 0-2.154zM8.016 6.892a1.077 1.077 0 0 0 0 2.154h.008a1.077 1.077 0 1 0 0-2.154zM11.908 6.892a1.077 1.077 0 0 0 0 2.154h.008a1.077 1.077 0 1 0 0-2.154z" }, null, -1)
  ]))]))
}
export default { render: render }